import SSOAlert from './SSOAlert'
export default SSOAlert
